export const FORM_STEP_MAP = new Map([
  ['first', 'first'],
  ['second', 'second']
]);
